import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";

import { Modal, Button } from "react-bootstrap";

const AdminPopupDismissableModal = forwardRef((props, ref) => {
  const [show, setShow] = useState(props.initialStateOpen || false);

  useEffect(() => {
    if (props.onComponentUpdated && typeof props.onComponentUpdated === "function") {
      props.onComponentUpdated();
    }
  }, [props.onComponentUpdated]);

  const handleClose = useCallback(
    (event = null) => {
      if (props.handleModalVisiblityFromParent) {
        props.setModalVisibility();
      } else {
        setShow(false);
        if (props.onClose && typeof props.onClose === "function") {
          props.onClose();
        }
        if (props.invertButton && typeof props.invertButton === "function") {
          props.invertButton();
        }
      }
    },
    [props.handleModalVisiblityFromParent, props.setModalVisibility, props.onClose, props.invertButton]
  );

  const handleShow = useCallback(() => {
    if (props.handleModalVisiblityFromParent) {
      props.setModalVisibility();
    } else {
      setShow(true);
      if (props.onShow && typeof props.onShow === "function") {
        props.onShow();
      }
    }
  }, [props.handleModalVisiblityFromParent, props.setModalVisibility, props.onShow]);

  useImperativeHandle(ref, () => ({
    handleShow,
    handleClose,
  }));

  return (
    <Modal
      id={"modal " + (props.modalId ? props.modalId : "")}
      key={2}
      show={(props.handleModalVisiblityFromParent && props.isModalVisible) || show}
      onHide={handleClose}
      style={props.customModalStyle}
      size={props.size !== undefined ? props.size : null}
      dialogClassName={props.modalClassName}
      backdrop={props.preventCloseWhenClickedOutsideModal ? "static" : true}
      keyboard={props.keyboard !== undefined ? props.keyboard : true}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
      {props.hideFooter ? null : (
        <Modal.Footer>
          {props.customFooterContent !== undefined ? (
            props.customFooterContent
          ) : (
            <Button onClick={handleClose} variant="outline-dark">
              Close
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
});

export default AdminPopupDismissableModal;
